import React, { useState, useEffect, useRef } from 'react';
import { get, patch } from '../../../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../../util/constant';
import { Table, Form } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../../Pagination';
import useDebounce from '../../useDebounce';
import { GrDocumentExcel } from 'react-icons/gr';
import { FiSave } from 'react-icons/fi';

const GodownItems = ({ type, title }) => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemList, setItemList] = useState([]);
  const [query, setQuery] = useState('');
  const clickToDownload = useRef();
  function getItems(conditionType) {
    try {
      let url = '';
      if (conditionType && conditionType === 'download') {
        url = `/inv/items/?class=Godown&query=${query}&type=${type}&conditionType=download`;
      } else {
        url = `/inv/items/?class=Godown&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${query}&type=${type}`;
      }
      get(url).then((response) => {
        if (conditionType && conditionType === 'download') {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setItemList(response.data.rows);
          setTotalRecords(response.data.count ?? 0);
        }
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getItems();
      }
    },
    [query],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getItems();
  }, [currentPage]);

  const handleSubmit = (itemId, index) => {
    patch({ rate: itemList[index]?.rate, gst: itemList[index]?.gst }, `/inv/items/${itemId}`)
      .then((res) => {
        toast.success(res.data.message);
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message) || 'Something went wrong');
  };

  return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            {title} | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              type="search"
              placeholder="Search by name"
              style={{ width: '250px', marginRight: '20px' }}
            />
            <GrDocumentExcel
              title="Download excel report"
              className="react-icons green"
              style={{ width: '30px', height: '30px', cursor: 'pointer' }}
              onClick={() => getItems('download')}
            />
            <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>HSN Code</th>
                    <th>HSN Description</th>
                    <th>Class</th>
                    <th>Rate Per Unit</th>
                    <th>GST%</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {itemList.map((item, index) => {
                    return (
                      <tr key={item?.id}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>
                          {item?.name} ({item?.unit})
                        </td>
                        <td>{item?.hsnCode}</td>
                        <td>{item?.hsnDesc}</td>
                        <td>{item?.class}</td>
                        <td>
                          <input
                            value={item.rate ?? ''}
                            name="rate"
                            onChange={(e) => {
                              const value = e.target.value;
                              if (!isNaN(value) && value >= 0) {
                                const newList = [...itemList];
                                newList[index].rate = value;
                                setItemList(newList);
                              }
                            }}
                            type="text"
                            placeholder="Enter Rate"
                          />
                        </td>
                        <td>
                          <input
                            value={item.gst ?? ''}
                            name="gst"
                            onChange={(e) => {
                              const value = e.target.value;
                              if (!isNaN(value) && value >= 0) {
                                const newList = [...itemList];
                                newList[index].gst = value;
                                setItemList(newList);
                              }
                            }}
                            type="text"
                            placeholder="Enter GST"
                          />
                        </td>
                        <td>
                          <FiSave
                            title="Update Item rate&gst"
                            style={{ cursor: 'pointer', height: '25px', width: '25px', color: 'green', marginLeft: '6px' }}
                            onClick={() => handleSubmit(item?.id, index)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GodownItems;
